export default "__VITE_PUBLIC_ASSET__c706334c__"